import { createClient } from '@supabase/supabase-js'

/**
 * Supabase Client Configuration
 * Initializes the Supabase client with project credentials
 * This client handles all authentication and database operations
 */

// Get environment variables for Supabase configuration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Validate required environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.')
}

// Create and export Supabase client instance
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Disable email confirmation for simpler user experience
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})